import './styles/icon_svg.styl';
import './styles/theme.scss';

import app from './scripts/app.js';
exports.app = app;



// WEBPACK FOOTER //
// ./src/test/index.js